import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { streaksBarActionTypes } from './Constants';
import * as errorHandlerActions from '../errorHandler/Actions';
import * as streaksBarActions from './Actions';

export default function* () {
	yield all([
		yield takeLatest(streaksBarActionTypes.GET_STREAKS_INFO, handleGetStreaksInfoRequest),
	]);
}

export function* handleGetStreaksInfoRequest() {
	try {
		const { data } = yield call(processRequest, 'get_user_data/streak');
		yield put(streaksBarActions.getStreaksInfoSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(streaksBarActions.getStreaksInfoError());
	}
}
